package com.nonopn.skywatcher.common.login.sub

import androidx.compose.desktop.ui.tooling.preview.Preview
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.ILoginCaller
import com.nonopn.skywatcher.common.login.LocalOpenSessionModel
import com.nonopn.skywatcher.common.login.pages.RouterLogin
import com.nonopn.skywatcher.common.login.pages.RouterRegister
import eu.codlab.blipya.common_sub_login.generated.resources.Res
import eu.codlab.blipya.common_sub_login.generated.resources.app_sub_title
import eu.codlab.blipya.common_sub_login.generated.resources.create_account_title
import eu.codlab.blipya.common_sub_login.generated.resources.login_account_title
import eu.codlab.compose.widgets.CustomOutlinedButton
import eu.codlab.compose.widgets.TextNormal
import eu.codlab.compose.widgets.TextSubtitle
import eu.codlab.compose.widgets.TextTitle
import eu.codlab.compose.widgets.preview.PreviewDarkLightColumn
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

@Suppress("UnusedPrivateMember")
@Composable
fun MainNotLoggedScreen(
    appMainTitle: StringResource,
    loginCaller: ILoginCaller,
    modifier: Modifier = Modifier
) {
    val model = LocalOpenSessionModel.current
    println("openSessionModel ? ${model.id}")
    Column(modifier = Modifier.padding(16.dp)) {
        TextTitle(
            text = stringResource(appMainTitle)
        )
        TextSubtitle(
            text = stringResource(Res.string.app_sub_title)
        )
        Row(
            modifier
                .background(Color.Transparent)
                .fillMaxWidth(),
            Arrangement.spacedBy(5.dp)
        ) {
            Spacer(modifier = Modifier.weight(1f))

            Column(
                Modifier
                    .background(Color.Transparent)
                    .width(IntrinsicSize.Max),
                Arrangement.spacedBy(5.dp)
            ) {
                CustomOutlinedButton(
                    modifier = Modifier.fillMaxWidth(),
                    onClick = { model.show(RouterRegister.navigateTo()) },
                    content = { TextNormal(stringResource(Res.string.create_account_title)) }
                )

                CustomOutlinedButton(
                    modifier = Modifier.fillMaxWidth(),
                    onClick = { model.show(RouterLogin.navigateTo()) },
                    content = { TextNormal(stringResource(Res.string.login_account_title)) }
                )
            }
        }
    }
}

@Preview
@Composable
private fun MainNotLoggedScreenDisplayPreview() {
    PreviewDarkLightColumn(
        submodifier = {
            Modifier
                .fillMaxWidth()
                .weight(1f)
        }
    ) { modifier, _ ->
        MainNotLoggedScreen(
            appMainTitle = Res.string.app_sub_title,
            loginCaller = object : ILoginCaller {
                override fun register(
                    email: String,
                    password: String,
                    callback: (err: Throwable?) -> Unit
                ) = Unit

                override fun login(
                    email: String,
                    password: String,
                    callback: (err: Throwable?) -> Unit
                ) = Unit
            },
            modifier = modifier
        )
    }
}
